import React from "react";
import PropTypes from "prop-types";

import Table from "../Table";
import TableRow from "../Table/TableRow";
import PPNFeesLink from "./PPNFeesLink";

/**
 * Returns "(x2)" if param is 2, "(x3)" if param is 3 etc.
 * @param {Number} numberOfETickets
 * @returns {String} multiplier string
 */
function displayMultiplier(numberOfETickets) {
  return numberOfETickets > 1 ? `(x${numberOfETickets})` : "";
}

const ChargesSummaryTable = ({
  numberOfETickets,
  fwdlookFees,
  totalCost,
  ppnBaseFare,
  ppnTaxesAndFees,
  ppnFees
}) => {
  return (
    <Table>
      <TableRow
        left="Ticket Price"
        right={`${displayMultiplier(numberOfETickets)} $${ppnBaseFare}`}
      />
      <TableRow
        left={<PPNFeesLink linkText={`Taxes & Fees`} />}
        right={`${displayMultiplier(numberOfETickets)} $${ppnTaxesAndFees}`}
      />
      {Number(ppnFees) ? (
        <TableRow
          left={<PPNFeesLink linkText="Processing Fees" />}
          right={`${displayMultiplier(numberOfETickets)} $${ppnFees}`}
        />
      ) : (
        ""
      )}
      <TableRow left="Booking Cost" right={`$${fwdlookFees}`} />
      <TableRow left="Number of E-Tickets" right={numberOfETickets} />
      <TableRow left="Total Price" right={`$${totalCost}`} borderTop={true} />
    </Table>
  );
};

ChargesSummaryTable.propTypes = {
  ppnBaseFare: PropTypes.number.isRequired,
  ppnTaxesAndFees: PropTypes.number.isRequired,
  ppnFees: PropTypes.number.isRequired,
  numberOfETickets: PropTypes.number.isRequired,
  fwdlookFees: PropTypes.number.isRequired,
  totalCost: PropTypes.number.isRequired
};

export default ChargesSummaryTable;



// WEBPACK FOOTER //
// ./src/components/ChargesSummaryTable/index.js